"use client";

import { useSelector } from "react-redux";
import Myservices from "./serviceDetails";
import serviceDetailsCss from  "../../../styles/myAccount/serviceDetails.module.scss";

export default function ServiceDetails ()  { 
  let selectedServiceAddress = useSelector((state) => state.accountSummary.selectedServiceAddress);
  
  return (
    <>
    {global.window && window.localStorage ? 
      <Myservices key={selectedServiceAddress} serviceDetailsCss={serviceDetailsCss} /> : ''}
    </>
  )
}
